import mutations from './cloud.mutations';
import actions from './cloud.action';
import getters from '@/store/modules/cloud/services/cloud.getter';

// import { mutations } from './app.mutations';
export interface State {
  cloudSvc: string;
  cloudVendor: string;
  currentGKECluster: Object;
  currentGKENamespace: Object;
  gkeClusters: any[];
  gkeNamespaces: any[];
  currentGkeTab: string;
}

export const initialState: State = {
  cloudSvc: '',
  cloudVendor: '',
  currentGKECluster: {},
  currentGKENamespace: {},
  gkeClusters: [],
  gkeNamespaces: [],
  currentGkeTab: ''
};
export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions,
  getters,
};
